/**
 * ParkingPayment API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TransactionDetailDto } from './transactionDetailDto';


export interface PagedTicketResponseDto { 
    id?: number;
    guid?: string;
    locationId?: number;
    locationCode?: string | null;
    locationName?: string | null;
    creationTime?: string;
    totalHours?: number;
    startDateTime?: string;
    endDateTime?: string;
    totalAmount?: number;
    vehicleRegistrationNo?: string | null;
    phoneNumber?: string | null;
    isSuccess?: boolean;
    status?: string | null;
    transactions?: Array<TransactionDetailDto> | null;
}

